import { render, staticRenderFns } from "./CommonTechnicalData.vue?vue&type=template&id=d0c354b4&scoped=true"
import script from "./CommonTechnicalData.vue?vue&type=script&lang=js"
export * from "./CommonTechnicalData.vue?vue&type=script&lang=js"
import style0 from "./CommonTechnicalData.vue?vue&type=style&index=0&id=d0c354b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0c354b4",
  null
  
)

export default component.exports